import popadela from "../assets/images/popadela.jpg";
import popdaiana from "../assets/images/popdaiana.jpeg";
import popalex from "../assets/images/popalex.jpg";
import popanca from "../assets/images/popanca.jpg";
import buzguta from "../assets/images/buzgutavioleta.png";

const DoctorsPage = () => {
  const doctors = [
      {
      id: 4,
      name: "Dr. Buzguța Violeta",
      specialty: "Medic primar stomatologie generală, competență în implantologie",
      experience: "fondator Artisan Stoma",
      image: buzguta
    },
    {
      id: 3,
      name: "Dr. Pop-Trifoi Anca",
      specialty: "Medic rezident ortodonție și ortopedie maxilo-facială",
      experience: "",
      image: popanca
    },
    {
      id: 2,
      name: "Dr. Pop Alexandru",
      specialty: "Medic specialist stomatologie generală",
      experience: "",
      image: popalex
    },
    {
      id: 1,
      name: "Dr. Pop Adela",
      specialty: "Medic stomatolog",
      experience: "",
      image: popadela
    },
    {
      id: 5,
      name: "Dr. Pop Daiana",
      specialty: "Medic rezident stomatologie generală",
      experience: "",
      image: popdaiana
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12">
      {/* TITLU */}
      <div className="text-center mb-14">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Doctorii Noștri
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Cunoaște echipa noastră de specialiști dedicați sănătății zâmbetului tău.
        </p>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {doctors.map((doctor) => (
          <div
            key={doctor.id}
            className="
              group
              bg-white
              rounded-xl
              shadow-md
              overflow-hidden
              transition-all
              duration-300
              hover:-translate-y-2
              hover:shadow-xl
            "
          >
            {/* IMAGINE */}
            <div className="relative overflow-hidden">
              <img
                src={doctor.image}
                alt={doctor.name}
                loading="lazy"
                decoding="async"
                className="
                  w-full
                  h-64
                  object-cover
                  object-[center_0%]
                  transition-transform
                  duration-500
                  group-hover:scale-110
                "
              />

              {/* overlay subtil */}
              <div className="
                absolute inset-0
                bg-gradient-to-t
                from-black/30
                to-transparent
                opacity-0
                group-hover:opacity-100
                transition-opacity
              " />
            </div>

            {/* CONTINUT */}
            <div className="p-6 text-center">
              <h3 className="text-lg font-semibold text-gray-800 mb-1">
                {doctor.name}
              </h3>
              <p className="text-blue-600 font-medium mb-2">
                {doctor.specialty}
              </p>
              <p className="text-gray-500 text-sm">
                {doctor.experience}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoctorsPage;
